import React, { useEffect, useState } from "react";

// Registers the service worker and, when a fresh deploy is waiting, shows a
// "New version available" banner. Tapping Refresh activates the new worker and
// reloads — so the cached (offline-capable) app never gets out of date.
export const UpdatePrompt = () => {
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return undefined;
    let reg;
    let refreshing = false;

    const onControllerChange = () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    };
    navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);

    const track = (worker) => {
      if (!worker) return;
      worker.addEventListener("statechange", () => {
        if (worker.state === "installed" && navigator.serviceWorker.controller) setWaiting(worker);
      });
    };

    navigator.serviceWorker
      .register("/sw.js")
      .then((r) => {
        reg = r;
        if (r.waiting && navigator.serviceWorker.controller) setWaiting(r.waiting);
        r.addEventListener("updatefound", () => track(r.installing));
      })
      .catch(() => {});

    // Check for a new deploy periodically while the app stays open.
    const id = setInterval(() => { if (reg) reg.update().catch(() => {}); }, 60 * 60 * 1000);

    return () => {
      navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
      clearInterval(id);
    };
  }, []);

  if (!waiting) return null;

  const refresh = () => { waiting.postMessage({ type: "SKIP_WAITING" }); };

  return (
    <div
      data-testid="update-prompt"
      style={{
        position: "fixed",
        left: "50%",
        bottom: 16,
        transform: "translateX(-50%)",
        zIndex: 9998,
        background: "#0a192f",
        color: "#fff",
        padding: "10px 14px",
        display: "flex",
        alignItems: "center",
        gap: 12,
        borderRadius: 9999,
        boxShadow: "0 6px 24px rgba(0,0,0,0.35)",
        fontSize: 13,
        fontWeight: 600,
        maxWidth: "calc(100vw - 24px)",
      }}
    >
      <span data-testid="update-prompt-text">A new version is available.</span>
      <button
        type="button"
        onClick={refresh}
        data-testid="update-refresh-btn"
        style={{
          background: "#facc15",
          color: "#0a192f",
          border: "none",
          padding: "5px 14px",
          borderRadius: 9999,
          fontWeight: 700,
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        Refresh
      </button>
    </div>
  );
};

export default UpdatePrompt;
